import { Stack } from '@mui/material';
import { SwitchElement, TextFieldElement, useFormContext } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { DescriptionFootersFormValues } from '../types';

interface DescriptionFooterItemProps {
  index: number;
}

/** Fields for a single description footer row inside the field array. */
export function DescriptionFooterItem({ index }: DescriptionFooterItemProps) {
  const { $t } = useIntl();
  const { watch, setValue } = useFormContext<DescriptionFootersFormValues>();
  const descriptionFooters = watch('descriptionFooters');

  /** Ensures only one footer can be marked as default at a time. */
  function handleDefaultChange(isDefault: boolean) {
    if (!isDefault) {
      return;
    }
    descriptionFooters.forEach((_, i) => {
      if (i !== index) {
        setValue(`descriptionFooters.${i}.default`, false);
      }
    });
  }

  return (
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ md: 'center' }}>
        <TextFieldElement
          label={$t({
            id: 'common.text.name',
            defaultMessage: 'Nombre',
          })}
          name={`descriptionFooters.${index}.name`}
          required
          fullWidth
          sx={{ flex: 1 }}
        />
        <SwitchElement
          name={`descriptionFooters.${index}.default`}
          label={$t({
            id: 'admin.fragments.useAsDefault',
            defaultMessage: 'Usar como default',
          })}
          switchProps={{
            onChange: (_e, checked) => handleDefaultChange(checked),
          }}
        />
      </Stack>
      <TextFieldElement
        label={$t({
          id: 'common.text.content',
          defaultMessage: 'Contenido',
        })}
        name={`descriptionFooters.${index}.content`}
        required
        fullWidth
        multiline
        rows={3}
      />
    </Stack>
  );
}
